<template>
    <ui-data-table 
        :p-headers="headers"
        p-title="Rodizios - Kits"
        p-read-link="kits.read.one"
        p-create-link="kits.create"
        p-name="kits"
    />
</template>
<script>

import {uiDataTable} from '@/components/ui'
export default {
    name: 'vwKitsRead',
    components: {
        uiDataTable  
    },
    data(){
        return {
            headers: [{
                text: 'id',
                value: 'id'
            }, {
                text: 'descrição',
                value: 'descricao'
            }, {
                text: 'Cadastrado',
                value: 'criado_em'
            }, {
                text: 'Ações', 
                value: 'actions', 
                sortable: false
            }],
        }
    },
}
</script>